(function () {
  'use strict';

  var picker = document.querySelector('[data-cc-birthflower-picker]');
  if (!picker) return;

  var minFlowers = parseInt(picker.dataset.minFlowers, 10) || 1;
  var maxFlowers = parseInt(picker.dataset.maxFlowers, 10) || 1;
  var pickerLabel = picker.dataset.label || 'Birth flower';
  var property = picker.dataset.property || 'Birthflowers';

  // Single-slot mode (max 1): no count selector — one slot is rendered straight
  // away and the grid opens to a single pick, exactly like single birthstone /
  // single initial. Multi mode (max > 1) mirrors the birthstone count picker.
  var singleMode = maxFlowers === 1;

  var countSelector = picker.querySelector('[data-cc-count-selector]');
  var slotsContainer = picker.querySelector('[data-cc-slots]');
  var panel = picker.querySelector('[data-cc-flower-panel]');
  var removeBtn = picker.querySelector('[data-cc-remove-btn]');
  var hiddenInput = picker.querySelector('[data-cc-birthflowers-input]');

  // count   = chosen N (single mode pins it to 1). flowers = fixed array of
  // length count, each entry null (empty) or { month, abbrev, flower }.
  // activeSlot = the slot the next flower fills / that the panel targets. Always
  // a valid index while count > 0, null only when there are no slots.
  //
  // gridOpen: the panel shows while slots remain empty and auto-CLOSES once every
  // slot holds a flower. Picking auto-advances to the next empty slot (panel
  // stays); when none remain it closes. Tapping any slot reopens the panel with
  // that slot active. No outside-click dismiss. Single mode starts open (one empty slot).
  var count = singleMode ? 1 : 0;
  var flowers = singleMode ? [null] : [];
  var activeSlot = singleMode ? 0 : null;
  var gridOpen = singleMode;

  // First still-empty slot in [0, count), or -1 if every slot is filled.
  function nextEmptySlot() {
    for (var i = 0; i < count; i++) { if (!flowers[i]) return i; }
    return -1;
  }

  // Reuses the birthstone picker's cc-birthstone-picker__* CSS classes for all
  // styling; behavior is scoped by data-cc-flower / data-cc-birthflower-picker.
  function findCell(month) {
    return panel.querySelector('[data-cc-flower][data-month="' + month + '"]');
  }

  // Order-data contract mirrors the birthstone picker (Alex's numbered format):
  //   2+  properties[Birth Flower 1] = "Lily of the Valley (May)", [2] = ...
  //   1   properties[Birth Flower]   = "Rose (June)"
  //   The old space-joined properties[<property>] input is retired in place.
  //   Event count === real filled flowers at add-to-cart: emit 0 while any slot
  //   is empty (keeps ATC gated), the full N only when every slot holds a month.
  function emit() {
    var filled = flowers.filter(Boolean);
    var allFilled = count > 0 && filled.length === count;

    window.ccWriteNumberedProps(picker, 'Birth Flower', filled.map(function (f) {
      return f.flower + ' (' + window.ccMonthName(f.month) + ')';
    }));
    window.ccRetireJoinedInput(hiddenInput);

    document.dispatchEvent(new CustomEvent('cc:birthflowers-changed', {
      detail: {
        property: property,
        count: allFilled ? count : 0,
        selectedCount: count,
        items: filled.map(function (f) { return f.flower; }),
        label: pickerLabel,
        min: minFlowers
      }
    }));
  }

  function renderCountSelector() {
    if (!countSelector) return;
    countSelector.querySelectorAll('[data-cc-count]').forEach(function (btn) {
      var isOn = parseInt(btn.dataset.ccCount, 10) === count;
      btn.classList.toggle('is-selected', isOn);
      btn.setAttribute('aria-pressed', isOn ? 'true' : 'false');
    });
  }

  function renderSlots() {
    slotsContainer.innerHTML = '';

    for (var i = 0; i < count; i++) {
      var entry = flowers[i];
      var slot = document.createElement('button');
      slot.type = 'button';
      slot.dataset.index = i;

      if (entry) {
        slot.className = 'cc-birthstone-picker__slot cc-birthstone-picker__slot--filled';
        if (activeSlot === i) slot.className += ' is-editing';
        slot.setAttribute('aria-label', entry.flower + '. Tap to change or remove.');

        // Clone the swatch from the panel cell — single source of truth for
        // src/srcset/sizes/alt lives in the snippet markup, not duplicated here.
        var cell = findCell(entry.month);
        var cellImgs = cell ? cell.querySelectorAll('img') : [];
        cellImgs.forEach(function (cellImg) {
          var slotImg = cellImg.cloneNode(true);
          slotImg.className = 'cc-birthstone-picker__slot-img';
          slotImg.removeAttribute('loading');
          slot.appendChild(slotImg);
        });

        var label = document.createElement('span');
        label.className = 'cc-birthstone-picker__slot-label';
        label.textContent = entry.abbrev;
        slot.appendChild(label);
      } else {
        slot.className = 'cc-birthstone-picker__slot cc-birthstone-picker__slot--active';
        if (activeSlot === i) slot.className += ' is-editing';
        slot.setAttribute('aria-label', 'Empty slot ' + (i + 1) + '. Tap to choose a birth month.');
      }

      (function (idx) {
        slot.addEventListener('click', function (e) { e.stopPropagation(); setActiveSlot(idx); });
      })(i);
      slotsContainer.appendChild(slot);
    }
  }

  function render() {
    renderCountSelector();
    renderSlots();

    // Panel shows while incomplete (gridOpen), closes when every slot is filled.
    panel.hidden = !gridOpen;
    // Gold clear/remove only shows when the active slot holds a flower.
    removeBtn.hidden = activeSlot === null || !flowers[activeSlot];

    // Highlight the panel cell matching the active slot.
    panel.querySelectorAll('[data-cc-flower]').forEach(function (cell) {
      var isSelected = activeSlot !== null
        && flowers[activeSlot]
        && flowers[activeSlot].month === cell.dataset.month;
      cell.classList.toggle('is-selected', isSelected);
    });

    emit();
  }

  function setCount(n) {
    if (n === count) return;
    if (n < count) {
      flowers = flowers.slice(0, n);
    } else {
      while (flowers.length < n) flowers.push(null);
    }
    count = n;
    // Point at the first fillable slot and open the panel; if the new count is
    // already fully filled (e.g. lowering N), close it. Null/closed at count 0.
    if (count === 0) {
      activeSlot = null;
      gridOpen = false;
    } else {
      var e = nextEmptySlot();
      if (e === -1) { activeSlot = count - 1; gridOpen = false; }
      else { activeSlot = e; gridOpen = true; }
    }
    render();
  }

  // Re-point which slot the panel fills AND (re)open it — used when the shopper
  // taps a slot to edit it, including a filled slot on a completed selection.
  function setActiveSlot(index) {
    activeSlot = index;
    gridOpen = true;
    render();
    panel.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
  }

  if (countSelector) {
    countSelector.querySelectorAll('[data-cc-count]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.stopPropagation();
        setCount(parseInt(this.dataset.ccCount, 10));
      });
    });
  }

  panel.querySelectorAll('[data-cc-flower]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      if (activeSlot === null) return;
      flowers[activeSlot] = {
        month: this.dataset.month,
        abbrev: this.dataset.abbrev,
        flower: this.dataset.flower
      };
      // Auto-advance to the next empty slot (panel stays open); when every slot
      // is filled, close the panel. Tapping a slot later reopens it to edit.
      var e = nextEmptySlot();
      if (e !== -1) { activeSlot = e; }
      else { gridOpen = false; }
      render();
    });
  });

  removeBtn.addEventListener('click', function () {
    // Clears the active slot back to empty (does not remove it — count is fixed),
    // keeps it active and reopens the panel for a re-pick.
    if (activeSlot !== null && flowers[activeSlot]) {
      flowers[activeSlot] = null;
      gridOpen = true;
      render();
    }
  });

  // Fire once on init: single mode already has its one slot (panel visible);
  // multi waits for a count pick. Either way emit() seeds the switcher's gate
  // before interaction.
  render();
})();
